import { Controller } from '@hotwired/stimulus';

// Generic, app-agnostic primitive: dispatches a named CustomEvent on
// `window` when triggered. Lets independent components/controllers
// communicate without any direct DOM coupling (no shared id, no ancestor
// relationship required).
//
// Usage:
//   %button{ data: { controller: 'event-dispatcher',
//                     event_dispatcher_name_value: 'some:event',
//                     action: 'click->event-dispatcher#send' } }
export default class extends Controller {
  static values = { name: String, detail: Object };

  send() {
    window.dispatchEvent(new CustomEvent(this.nameValue, { detail: this.detailValue }));
  }
}
